<template>
  <section class="big-image">
    <LineText
      v-if="data.lineText !== undefined"
      :title="data.lineText"
    />

    <div
      v-if="data.intro !== undefined"
      class="big-image__intro c-container c-container--small"
    >
      <p
        v-for="(text, i) in data.intro"
        :key="`intro-${i}`"
        data-anim="paragraph"
      >
        {{ text }}
      </p>
    </div>

    <div
      :class="[
        'c-container',
        'c-container--big',
        data.titleImage !== undefined ? 'c-container--flex' : false,
      ]">
      <AppFigure
        :class="[
          'big-image__picture',
          data.titleImage !== undefined ? 'big-image__picture--small' : false,
        ]"
        :data="{ src: data.src, alt: data.alt }"
      />
      <AppDescription
        class="big-image__picture-text"
        v-if="data.contentImage !== undefined"
        :data="{ title: data.titleImage, content: data.contentImage }"
      />
    </div>

    <div
      v-if="data.description !== undefined"
      class="c-container c-container--small big-image__description"
    >
      <h4 data-anim="title">{{ data.titleDescription}}</h4>
      <p
        v-for="(text, i) in data.description"
        :key="`description-${i}`"
          :style="{
          maxWidth: data.descriptionSmall ? '350px' : false,
        }"
        data-anim="paragraph"
      >
        {{ text }}
      </p>
    </div>
  </section>
</template>

<script>
import LineText from '@/components/LineText.vue';
import AppFigure from '@/components/AppFigure.vue';
import AppDescription from '@/components/AppDescription.vue';

export default {
  name: 'BigImage',

  components: {
    LineText,
    AppFigure,
    AppDescription,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~sass-mq/mq";
@import '../scss/utils';

.big-image {
  &__intro  p {
    display: inline-block;
    margin-bottom: 20px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  .c-container--flex {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    flex-flow: row wrap;
  }

  &__picture {
    margin: 40px 0;

    @include aspect-ratio(16, 7);

    &--small {
      display: inline-block;
      width: 100%;
      @include aspect-ratio(16, 9);

      @include mq(ipadP) {
        width: 60%;
      }
    }

    &-text {
      display: inline-block;
      width: 100%;
      margin-bottom: 30px;

      @include mq(ipadP) {
        width: 30%;
      }

      &::v-deep h3 {
        margin-bottom: 20px;
      }
    }
  }

  &__description h4 {
    margin-bottom: 20px;
  }
}
</style>
